import styled from 'styled-components';

export const FormsWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  column-gap: 20px;
  align-items: flex-start;
  margin-top: ${({ theme: { spacing } }) => spacing(30)};
`;
